import {fetch} from './api/v1';

export type ConnectionExportFormat = 'pdf' | 'docx';

const exportError = (status: number) => {
  if (status === 401) return 'Сессия истекла. Пожалуйста, войдите в аккаунт.';
  if (status === 403) return 'Нет доступа к скачиванию этой заявки.';
  if (status === 404) return 'Заявка не найдена или недоступна.';
  return 'Не удалось скачать файл. Попробуйте ещё раз.';
};

export const connectionExportFilename = (header: string | null, fallback: string) => {
  const encoded = header?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plain = header?.match(/filename="([^"]+)"|filename=([^;]+)/i);
  let name = plain?.[1] ?? plain?.[2]?.trim();
  if (encoded) {
    try { name = decodeURIComponent(encoded); } catch { /* Используем обычное имя. */ }
  }
  const basename = name?.split(/[\\/]/).pop() ?? '';
  return Array.from(basename).filter((character) => character.charCodeAt(0) >= 32).join('') || fallback;
};

export const downloadConnection = async (id: number, format: ConnectionExportFormat, token: string) => {
  const {data, response} = await fetch.GET('/connections/{id}/export', {
    params: {path: {id}, query: {format}},
    headers: {Authorization: `Bearer ${token}`},
    parseAs: 'blob',
  });
  const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
  if (!response.ok || !(data instanceof Blob) || !data.size ||
      contentType.includes('json') || contentType.includes('text/')) {
    throw new Error(exportError(response.status));
  }
  const url = URL.createObjectURL(data);
  const link = document.createElement('a');
  try {
    link.href = url;
    link.download = connectionExportFilename(response.headers.get('content-disposition'), `connection-${id}.${format}`);
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Браузер должен успеть начать скачивание до освобождения URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};
